import { AlertTriangle, Ban } from "lucide-react";

export default function TenantNotFound({ suspended, tenant }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--tf-bg)] p-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-900 ring-1 ring-slate-800">
        {suspended ? <Ban className="text-rose-400" size={30} /> : <AlertTriangle className="text-amber-400" size={30} />}
      </div>
      <h1 className="mt-6 font-head text-3xl font-bold text-slate-50" data-testid="tenant-not-found-title">
        {suspended ? "Workspace Suspended" : "Tenant Not Found"}
      </h1>
      <p className="mt-2 max-w-md text-sm text-slate-400">
        {suspended
          ? `${tenant?.brand_name || "This workspace"} is currently suspended. Please contact your administrator.`
          : "No workspace is configured for this address. Please check the link or contact your administrator."}
      </p>
      <a href="https://trackingpanel.in" className="mt-8 text-sm text-emerald-400 hover:text-emerald-300">Go to TrackingPanel</a>
    </div>
  );
}
